import React from 'react'
import PhoneIcon from '@mui/icons-material/Phone';
import HeaderMainPage from '../Auth/Header/HeaderMainPage';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { darkModeBackgroud } from '../../utils/constants';
import { useDarkModeStore } from '../../store/useDarkModeStore';

const email = "b.ramusa@bpatec.com";
const number = '+383 (44) 440-222';

export const Support = () => {
    const { darkMode } = useDarkModeStore();

    return <div className="w-100 d-flex flex-column">
        <HeaderMainPage />
        <div className='w-100 h-100 d-flex flex-column align-items-center justify-content-center p-5'>
            <h1 className='main-header-color fw-bold'>Welcome to Line Desk Support</h1>
            <div className={`w-75 mt-3 ${darkMode && 'text-white'}`}>
                <p className='text-center mb-3'>Thank you for using LineHR! We're here to assist with any questions or support needs. Below, you'll find helpful resources and ways to get in touch. </p>
                <p className='text-center fw-bold mt-3'>Frequently Asked Questions (FAQ) </p>
                <div className='d-flex flex-column justify-content-center gap-4'>
                    <ul style={{ marginLeft: '25%', marginRight: '25%' }}>
                        <li className='fw-bold'>How do I get started with LineHR?</li>
                        <ul>
                            <li>To begin, download LineHR from the App Store and follow the setup guide within the app.</li>
                        </ul>
                        <li className='fw-bold'>How do I reset my password?</li>
                        <ul>
                            <li>If you’re unable to log in, please tap "Forgot Password" on the login screen to reset your password.</li>
                        </ul>
                        <li className='fw-bold'>How do I report an issue with the app?</li>
                        <ul>
                            <li>Use the Contact Us form below or email us directly to report any issues. Please provide details about your device and the problem.</li>
                        </ul>
                    </ul>
                    <p className='text-center mb-0'><strong>Troubleshooting Tips</strong> </p>
                    <ul style={{ marginLeft: '25%', marginRight: '25%' }}>
                        <li>Ensure your LineHR app is updated to the latest version.</li>
                        <li>Restart your device if you experience connectivity issues.</li>
                    </ul>
                </div>
            </div>
            <div className='d-flex flex-column'>
                <p className='text-center mb-3'><strong>Contact Us</strong>  </p>
                <p className='text-center'>If you need further assistance, reach out to our support team</p>
                <div className='d-flex justify-content-center'>
                    <div className='gap-3 d-flex flex-row w-100 mb-3' style={{ height: 165 }}>
                        <div
                            className='d-flex flex-column justify-content-center align-items-center w-50 p-3'
                            style={{ background: darkMode ? darkModeBackgroud : '#E9EAEE', borderRadius: 3 }}
                        >
                            <span
                                className='d-flex align-items-center justify-content-center mb-4'
                                style={{ width: 46, height: 46, background: '#D5D5F1', color: '#8284FC', borderRadius: 5, marginBottom: 10 }}
                            >
                                <PhoneIcon />
                            </span>
                            <span
                                className='fw-bold'
                                style={{ color: darkMode ? 'white' : 'rgb(57,69,82)' }}
                            >
                                {number}
                            </span>
                            <span
                                className={`text-center ${darkMode ? 'text-white' : 'text-muted'}`}
                            >
                                (Available 9 AM - 5 PM, Monday to Friday)
                            </span>
                        </div>
                        <div className='d-flex flex-column justify-content-center align-items-center w-50 p-3' style={{ background: darkMode ? darkModeBackgroud : '#E9EAEE', borderRadius: 3 }}>
                            <span
                                className='d-flex align-items-center justify-content-center mb-4'
                                style={{ width: 46, height: 46, background: '#D5D5F1', color: '#8284FC', borderRadius: 5, marginBottom: 10 }}
                            >
                                <MailOutlineIcon />
                            </span>
                            <span
                                className='fw-bold'
                                style={{ color: darkMode ? 'white' : 'rgb(57,69,82)' }}
                            >
                                {email}
                            </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default Support;